export default {
  width: 12,
  height: 6,
  svg: `
<path fill-rule="evenodd" clip-rule="evenodd" d="M0.175384 0.199758C-0.0584618 0.420612 -0.0584618 0.778159 0.175384 0.998448L5.13352 5.66914C5.60182 6.11029 6.36152 6.11029 6.82981 5.66914L11.8245 0.964557C12.056 0.745962 12.059 0.392935 11.8305 0.171516C11.5973 -0.0549865 11.2129 -0.0572462 10.9761 0.165302L6.40589 4.47111C6.17144 4.69196 5.79189 4.69196 5.55744 4.47111L1.02323 0.199758C0.789381 -0.0210958 0.40983 -0.0210958 0.175384 0.199758Z"/>
`
}
